import { ProposalComment } from './ProposalComment';
import { IVehicle } from './Vehicle';

export interface Proposal {
  id: number;
  description:string;
  webPortalContactId: string;
  contactId: string;
  clientType: string;
  clientTypology: string;
  inputChannel: string;
  requestingChannel: string;
  totalFleet: number;
  comments: ProposalComment[];
  vehicles: IVehicle[];
  leaseQuoteNo: string;
  sendToApprovedDate:string;
  sendToApprovedValidateDate:string;
  //listagem de propostas
  clientName: string; 
  nif: string;
  salespersonCode: string;
  salesPersonName: string;
  state:string;
  isClientApproved:boolean;
  printProposalRentalTypeId: string;
  printProposalDestinationEmailAddress: string;
  printProposalTitle: string;
  printProposalComments: string;
  printProposalAttachments: File[];
  functionalGroup: string;
}
export const emptyProposal: Proposal = {
  id: 0,
  webPortalContactId: '',
  contactId: '',
  description: 'Proposta de aluguer',
  clientType: '',
  clientTypology: '',
  inputChannel: '0',
  requestingChannel: '',
  totalFleet: 0,
  comments: [],
  vehicles: [],
  leaseQuoteNo:  '',
  sendToApprovedDate: '',
  sendToApprovedValidateDate: '',
  //listagem de propostas
  clientName: '', 
  nif: '', 
  salespersonCode: '', 
  salesPersonName: '',
  state: 'Open',
  isClientApproved: false,
  printProposalRentalTypeId: '',
  printProposalDestinationEmailAddress: '',
  printProposalTitle: '',
  printProposalComments: '',
  printProposalAttachments: [],
  functionalGroup: '',
}